import { Button, ListItem } from "@mui/material";
import clsx from "clsx";
import type { FC, ReactNode } from "react";
import { NavLink as RouterLink, useLocation } from "react-router-dom";

interface NavItemProps {
    children?: ReactNode;
    className?: string;
    href?: string;
    info?: any;
    title: string;
}

const NavItem: FC<NavItemProps> = ({ className, href, info: Info, title, ...rest }) => {
    const location = useLocation();
    const isActive = location.pathname === href;
    return (
        <ListItem className={clsx(className)} disableGutters key={title} {...rest}>
            <Button
                sx={{
                    color: isActive ? "#394DFF" : "black",
                    fontSize: 16,
                    ":active": { color: "blue" },
                    textTransform: "none",
                    whiteSpace: "nowrap",
                }}
                disableFocusRipple={true}
                component={RouterLink}
                to={href}
            >
                {title}
                {Info && <Info />}
            </Button>
        </ListItem>
    );
};

export default NavItem;
